import { render, staticRenderFns } from "./WidgetAgenciesQuotationResume.vue?vue&type=template&id=5fafb7a2"
import script from "./WidgetAgenciesQuotationResume.vue?vue&type=script&lang=js"
export * from "./WidgetAgenciesQuotationResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports